import { Component, OnInit } from '@angular/core';
import _ from 'lodash';
import { Subject } from 'rxjs';
import { ArkUnitOfWork } from '../../core/core.module';

@Component({
    selector: 'app-user-detail',
    templateUrl: './user-detail.component.html',
    styleUrls: ['./user-detail.component.scss'],
    standalone: false,
})
export class UserDetailComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    user: any;
    roles: any[];
    stores: any[];
    departments: any[];
    currentRoleIds: number[];
    selectedRoleIds: number[];
    key: any;

    constructor(private uow: ArkUnitOfWork) {}

    async ngOnInit() {
        this.departments = this.uow.lookups.departments;
        this.stores = this.uow.lookups.stores;
        this.roles = this.uow.lookups.roles;

        if (this.key === 'new') {
            this.user = this.uow.users.createEntity();
        } else {
            this.user = await this.uow.users.byId(this.key, 'userRoles');
        }
        this.updateRoleIds();
    }

    updateRoleIds() {
        this.currentRoleIds = _(this.user.userRoles)
            .sortBy('role.name')
            .map((ur) => ur.roleId)
            .value();

        this.selectedRoleIds = this.currentRoleIds.slice();
    }

    hasChanges() {
        return this.uow.hasChanges() || JSON.stringify(this.selectedRoleIds) !== JSON.stringify(this.currentRoleIds);
    }

    async save() {
        const addedIds = _.difference(this.selectedRoleIds, this.currentRoleIds);
        const removedIds = _.difference(this.currentRoleIds, this.selectedRoleIds);

        addedIds.forEach((roleId) => {
            this.uow.createEntity('UserRole', { roleId, user: this.user });
        });

        removedIds.forEach((roleId) => {
            const ur = _(this.user.userRoles).find({ roleId: roleId } as any) as any;
            ur.entityAspect.setDeleted();
        });
        this.selectedRoleIds = this.currentRoleIds.slice();

        await this.uow.commit();

        this.updateRoleIds();
        // this.navigateOnSaveNew(this.user.id.toString());

        this.result.next({ success: true });
        return true;
    }

    async cancel() {
        // if (await super.cancel()) {
        //     this.selectedRoleIds = this.currentRoleIds.slice();
        //     return true;
        // }
        this.result.next({ success: false });

        return false;
    }

    // async delete() {
    //     // if (!(await confirm('Are you sure you want to delete this user?', 'Delete User?'))) return;

    //     this.user.active = false;
    //     await this.save();
    //     // this.close();
    // }
}
